import styled from 'styled-components';

export const Message = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 21px;
`;
